<template>
  <div class="applyFor" :class="{'isiOSX':isiOSX}">
  	<van-nav-bar v-if="isApp" title="申请加盟商"/>
    <img v-if="isApp" @click="reBack()" class="reback" src="../../assets/myInvest/reback.png">
    <div class="form">
	    <van-cell-group>
		    <van-field v-model="name" placeholder="请输入您的姓名" />
		    <van-field v-model="tel" type="number" placeholder="请输入您的电话" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')" maxlength="12" />
		    <van-field v-model="address" @click="toSelect" placeholder="请输入您的地址" />
		  </van-cell-group>
		  <img src="../../assets/myInvest/select.png">
    </div>
    <p class="btn">
	  	<span @click=submit>发送申请</span>
	  </p>
    <van-popup v-model="show" position="bottom" :overlay="true">
    	 <!--@change="onChange"-->
      <van-area :area-list="areaList" @cancel="cancel" @confirm="confirm($event)" />
    </van-popup>
  	
  </div>
</template>

<script>
export default {
  data() {
    return {
    	isApp: true,
      isiOSX: false,
      show: false,
      list: [],
      areaName: [],
      name: '',
      tel: '',
      address: '',
      phontCorrect: 0,
      areaList: {
			  province_list: {
//			    110000: '北京市',
//			    120000: '天津市'
			  },
			  city_list: {
//			    110100: '北京市',
//			    110200: '县',
//			    120100: '天津市',
//			    120200: '县'
			  },
			  county_list: {
//			    110101: '东城区',
//			    110102: '西城区',
//			    110105: '朝阳区',
//			    110106: '丰台区',
//			    120101: '和平区',
//			    120102: '河东区',
//			    120103: '河西区',
//			    120104: '南开区',
//			    120105: '河北区'
			  }
			}
    };
  },
  created() {
  	this.$api.setToken();
//	localStorage.removeItem('_token');
  	this.handleInput();
  	this.isiOSX = this.isIphoneX();
  	if(this.$route.query.from) {//app外
  		this.isApp = false;
  	}
		this.getArea();
  },
  methods: {
    handleInput() {
    	window.addEventListener("resize", function() {
				window.setTimeout(function() {
						document.activeElement.scrollIntoView(false);
					},1)
			})
    },
    getArea() {
    	this.$api.get("/platformsys/index/areas/list", {}).then(res => {
    		console.log(res)
    		this.list = res.list;
    		this.list.forEach(_ => {
            this.areaList.province_list[_.code] = _.name;
            _.children.forEach(__ => {
	        		this.areaList.city_list[__.code] =__.name;
	        		__.children.forEach(___ => {
            		this.areaList.county_list[___.code] =___.name;
            	})
	        	})
        })
    	});
    },
    toSelect() {
    	document.activeElement.blur();
    	this.show = true;
    },
    cancel() {
    	this.show = false;
    },
//  onChange (picker, value, index) {
//  	this.areaName = value;
//    this.address = ''
//    for (var i = 0; i < value.length; i++) {
//    	this.address = this.address + value[i].name + ' '
//    }
//    
//
//  },
    confirm(selected) {
    	this.show = false;
    	console.log(selected)
    	this.areaName = selected;
    	this.address = ''
      for (var i = 0; i < selected.length; i++) {
      	this.address = this.address + selected[i].name + ' '
      }
    },
    reBack() {
    	this.$router.go(-1);
    },
    verigyPhone() {
    	if(this.name == '') {
    		this.$toast('请输入您的姓名')
    		return false;
    	}
    	if(this.tel == '') {
        this.$toast('请输入您的电话')
    		return false;
      }else if(/^1\d{10}$/.test(this.tel) || /^\d{8}$/.test(this.tel) || /^\d{8}$/.test(this.tel) || /^\d{9}$/.test(this.tel)) {
        this.phontCorrect = 1;
      }else {
        this.$toast('手机号格式错误');
        return false;
      }
    	if(this.address == '') {
    		this.$toast('请输入您的地址')
    		return false;
    	}
    },
    submit() {
    	this.verigyPhone();
    	if(this.phontCorrect == 1 && this.name != '' && this.address != '') {
	    	this.$api.post("/offshop/index/franchise/join", {
	    		franchise_id: this.$route.query.type,
	    		username: this.name,
	    		phone: this.tel,
	    		province: this.areaName[0].code,
	    		city: this.areaName[1].code,
	    		district: this.areaName[2].code,
	    		address: this.address
	    	}).then(res => {
		      this.$toast('提交成功！');
		      this.$router.go(-1);
		    }).catch(err => {
		    	let keys = Object.keys(err);
		     	let key = keys[0];
		  		let message = err.message || err[key][0]
		//	      this.$toast(message);
		      if(message.slice(0, 10) == 'timeout of') {
		  			this.$toast('网络不给力，请稍候重试');
		  		}else {
		  			this.$toast(message);
		  		}
		    });
	    }
    }
  },
  mounted() {
  }
};
</script>

<style lang="less">
.applyFor {
  height: 100%;
  background: #f2f2f2;
  .van-nav-bar {
	  background: #f2f2f2;
	  padding-top: 24px;
	  position: relative;
	  .van-nav-bar__title {
	    font-size: 18px;
	    color: #333;
	  }
	  .van-nav-bar__text {
	    color: #333;
	    font-size: 14px;
	  }
	}
	.reback {
		width: 15px;
    padding: 12px 15px;
    position: fixed;
    top: 29px;
    left: 0;
    z-index: 2;
	}
	.form {
		padding: 8px 12px 0;
		position: relative;
		.van-cell-group {
			background: #FFFFFF;
			border-radius: 8px;
			padding: 0 12px;
			.van-field {
				height: 54px;
				line-height: 34px;
			}
		}
		.van-hairline--top-bottom:after, .van-hairline-unset--top-bottom:after {
	    border-width: 0px 0;
		}
		img {
			width: 15px;
			position: absolute;
			right: 23px;
			bottom: 24px;
		}
	}
	.btn {
		padding: 22px 12px;
		span {
			color: #FFFFFF;
			font-size: 16px;
			height: 44px;
			line-height: 44px;
			border-radius: 22px;
			display: inline-block;
			width: 100%;
			text-align: center;
			background: -webkit-linear-gradient(
        #FFB785,
        #FD786E
      ); /* Safari 5.1 - 6.0 */
      background: -o-linear-gradient(
        #FFB785,
        #FD786E
      ); /* Opera 11.1 - 12.0 */
      background: -moz-linear-gradient(
        #FFB785,
        #FD786E
      ); /* Firefox 3.6 - 15 */
      background: linear-gradient(
        #FFB785,
        #FD786E
      ); /* 标准的语法（必须放在最后） */
		}
		
	}
	.van-area {
		button {
			color: #333;
		}
	}
	
}
.isiOSX{
	.van-nav-bar {
		padding-top: 44px;
	}
	.reback {
		top: 49px;
	}
}
</style>
